module.exports = __webpack_public_path__ + "static/media/icon-search.24b7306f.svg";